"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
// This allows us to load Angular components on legacy server-side pages.
import { Component, Injector, NgModuleFactoryLoader, SkipSelf, ViewChild, ViewContainerRef, } from '@angular/core';
import '../app/rxjs-operators';
import { components } from './components';
var CompatComponent = (function () {
    function CompatComponent(injector, loader) {
        this.injector = injector;
        this.loader = loader;
    }
    CompatComponent.prototype.ngOnInit = function () {
        var _this = this;
        components
            .filter(function (_a) {
            var selector = _a.selector;
            return document.getElementsByTagName(selector)[0];
        })
            .forEach(function (_a) {
            var selector = _a.selector, loadChildren = _a.loadChildren, component = _a.component, path = _a.path;
            return _this.loader
                .load(loadChildren)
                .then(function (ngModuleFactory) {
                // NgModuleFactory
                var componentFactory = ngModuleFactory
                    .create(_this.injector) // ngModuleRef
                    .componentFactoryResolver.resolveComponentFactory(component);
                if (path === 'hack_path_not_used_index_0') {
                    _this.entryPoint.createComponent(componentFactory, 0);
                }
                else {
                    _this.entryPoint.createComponent(componentFactory);
                }
            });
        });
    };
    __decorate([
        ViewChild('entryPoint', { read: ViewContainerRef }),
        __metadata("design:type", ViewContainerRef)
    ], CompatComponent.prototype, "entryPoint", void 0);
    CompatComponent = __decorate([
        Component({
            selector: 'webapp-compat',
            template: "\n    <ng-container #entryPoint></ng-container>\n    <fl-modal></fl-modal>\n  ",
        }),
        __param(0, SkipSelf()),
        __metadata("design:paramtypes", [Injector,
            NgModuleFactoryLoader])
    ], CompatComponent);
    return CompatComponent;
}());
export { CompatComponent };



// WEBPACK FOOTER //
// compat.component.js